import { createContext } from 'react'
// Additional
import { Routing } from 'helpers/routing'

const RoundContext = createContext<{ params?: Routing.RoundParams }>({})

export { RoundContext }